import React, { useEffect } from 'react';

interface SimpleErrorModalProps {
  message: string;
  isOpen: boolean;
  onClose: () => void;
}

const SimpleErrorModal: React.FC<SimpleErrorModalProps> = ({ message, isOpen, onClose }) => {
  // Close the modal when Escape key is pressed
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        console.log('ErrorModal: Escape key pressed');
        onClose();
      }
    };

    // Prevent scrolling when modal is open
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleEscape);

    // Log when modal is opened
    console.log('ErrorModal: Modal opened');

    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleEscape);
      console.log('ErrorModal: Modal cleanup');
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Handle backdrop click
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      console.log('ErrorModal: Backdrop clicked');
      onClose();
    }
  };

  // Explicit close button handler
  const handleCloseClick = () => {
    console.log('ErrorModal: Close button clicked');
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleBackdropClick}
    >
      <div 
        className="bg-white p-8 rounded-lg shadow-xl max-w-md w-full"
        onClick={e => e.stopPropagation()}
      >
        <h3 className="text-xl font-semibold text-gray-800 mb-4">No Personas Found</h3>
        <p className="text-gray-600 mb-6">
          {message}
        </p>
        <div className="flex justify-end">
          <button
            onClick={handleCloseClick}
            className="px-4 py-2 bg-[#db2777] text-white rounded-md hover:bg-pink-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimpleErrorModal; 